<template>
  <div v-if="zone>0" class="zone flex justify-content-center flex-vertical"
    style="color:black"
    :style="{backgroundColor:colorZones[zone-1]}">
    <span class="h2">Target - Zone {{zone}}</span>
    <span class="h3">{{user.zones[zone-1].lower}} - {{user.zones[zone-1].upper}} bpm </span>  
  </div>
  <div v-else class="zone"></div>
</template>

<script>
  export default {
    name: 'targetZone',
    
    props: {
      zone: Number, 
      user:Object, 
      colorZones:Array,
    },
    data() {
      return {
      }
    },
    methods: {
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .zone {
    color:black;
    text-align:center;
  }

  .h3 {
    margin-top:0vw;
  }
</style>
